export default "__VITE_ASSET__DXC6D4PO__ 584w";